<template>
  <input
    ref="phoneInput"
    class="phone-input"
    id="phone-input"
    :readonly="readonly"
    :maxlength="maxlength"
    v-model="inputValue"
    @input="$emit('input', inputValue)"
  />
</template>

<script>
import { AsYouType } from 'libphonenumber-js'

export default {
  name: "PhoneInput",
  props: {
    value: String,
    readonly: Boolean,
    maxlength: {
      type: String,
      default: '13'
    }
  },
  data() {
    return {
      parsedPhoneNumber: null,
      inputValue: ''
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          this.inputValue = '';
          return;
        }

        let raw = newVal.replace(/\D/g, '');

        if (raw.startsWith('8') || raw.startsWith('0')) {
          raw = raw.slice(1);
        }

        const formattedNumber = '+' + raw;

        try {
          const formatted = new AsYouType().input(formattedNumber);
          this.parsedPhoneNumber = formatted;
          this.inputValue = formatted;
        } catch (error) {
          console.error(error);
          this.parsedPhoneNumber = null;
          this.inputValue = newVal;
        }
      }
    },
  },
  mounted() {
    if (this.value) {
      this.$watch('value', this.value);
    }
  }
};
</script>

<style scoped>
.phone-input {
  width: 100%;
  height: 100%;
  padding-left: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
}
</style>
